import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"scheme-preview"},[_c('scheme',{ref:"schemeElement",attrs:{"scheme":_vm.scheme,"show-result":true,"show-price":false},on:{"input":function($event){return _vm.$emit('input', $event)}}}),_c(VBtn,{staticClass:"button",attrs:{"disabled":!_vm.$store.getters.scheme_possible(_vm.scheme)},on:{"click":function($event){return _vm.$root.$emit('craft', _vm.scheme)}}},[_c(VIcon,[_vm._v("mdi-hammer-wrench")]),_vm._v(" Fabriquer")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }